import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { Plot, PlotUpdate } from "@farm/domain/models/plot.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { RecuperableModelError } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class PlotUpdateUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(farmId: number, plot: PlotUpdate): Promise<Nullable<Plot>> {
        const updateResult = await this.farmRepository.updatePlot(farmId, plot);

        return updateResult.match(
            (plotUpdated) => plotUpdated,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
